import { render } from "./MaintenacePage.vue?vue&type=template&id=5898206a&scoped=true"
import script from "./MaintenacePage.vue?vue&type=script&lang=js"
export * from "./MaintenacePage.vue?vue&type=script&lang=js"

import "./MaintenacePage.vue?vue&type=style&index=0&id=5898206a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5898206a"]])

export default __exports__